/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
// import { StyleSheet, ViewStyle } from "react-native";

interface ContainerIProps {
  containerViewStyle?: object;
  children?: React.ReactChild;
}

const styles = {
  container: {},
};

export const Container = (props: ContainerIProps) => {
  const { containerViewStyle, children } = props;

  return (
    <div
      style={{
        paddingLeft: 0,
        paddingRight: 0,
        position: "absolute",
        width: "100%",
      }}
    >
      {children}
    </div>
  );
};
